export const RESOURCE = 'adminuseraccount';
export const ACTIONS = { Get: '', GetSummary: '/summary', Update: '' }